export enum SentimentAnalysis {
  VERY_POSITIVE = 'VERY_POSITIVE',
  POSITIVE = 'POSITIVE',
  SLIGHTLY_POSITIVE = 'SLIGHTLY_POSITIVE',
  NEUTRAL = 'NEUTRAL',
  SLIGHTLY_NEGATIVE = 'SLIGHTLY_NEGATIVE',
  NEGATIVE = 'NEGATIVE',
  VERY_NEGATIVE = 'VERY_NEGATIVE'
}

export enum IntentClassification {
  APPOINTMENT = 'APPOINTMENT',
  INQUIRY = 'INQUIRY',
  COMPLAINT = 'COMPLAINT',
  FEEDBACK = 'FEEDBACK',
  SUPPORT = 'SUPPORT'
}

export interface ExtractedData {
  keyPoints: string[];
  nextSteps: string[];
  sentimentAnalysis: SentimentAnalysis;
  intentClassification: IntentClassification;
}

export interface ConversationAnalysis {
  summary: string;
  extractedData: ExtractedData;
}
